import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-hot-toast';
import useAuth from '../../../context/auth.context.jsx';
import { stashPendingReferral } from '../../utils/referral.js';

/**
 * Standalone landing for a personal referral link shared outside a group
 * invite (a story, a post) — `/i/:code`, as opposed to `/join/:code?i=...`
 * which pages/group.jsx's invite card uses (that one lands in a real group
 * too). Referral attribution only ever applies at account creation, so a
 * visitor who is already signed in gets a toast instead of anything
 * happening — there is nothing left here for them to claim.
 */
export default function ReferralLanding() {
    const { code } = useParams();
    const { user } = useAuth();
    const navigate = useNavigate();
    const { t } = useTranslation('common');

    useEffect(() => {
        if (user) {
            toast(t('referralAlreadySignedIn'));
            navigate('/', { replace: true });
            return;
        }
        stashPendingReferral(code);
        navigate('/register', { replace: true });
    }, [code, user, navigate, t]);

    return (
        <div className="route-loading" role="status" aria-live="polite">
            <span className="spinner-border" aria-hidden="true" />
        </div>
    );
}
